import { getObjectId } from '@/helpers/object.id.helper';
import type { Mode } from '@/types/entity-mode';
import { toFlowUiMode } from '@/components/flows/detail/normalize-flow-plan-view';
import { useFlowStore } from '@/state/stores/use-flow-store';
import { useModeStore } from '@/state/stores/use-mode-store';

export const useFlowMode = (flowIdOverride?: string): Mode => {
  const flow = useFlowStore((s) => s.flow);
  const flowPlan = useFlowStore((s) => s.flowPlan);
  const flowOrganize = useFlowStore((s) => s.flowOrganize);
  const flowMode = useModeStore((s) => s.flowMode);

  const flowId =
    flowIdOverride ??
    (flow?.origin ? (typeof flow.origin === 'string' ? flow.origin : getObjectId(flow.origin)) : flow?.id);

  if (flowId && flowMode[flowId]) {
    const requested = flowMode[flowId];
    if (requested === 'PLAN' && flowPlan) return requested;
    if ((requested === 'ORGANIZE' || requested === 'PERFORM') && flowOrganize) return requested;
  }

  if (flowPlan) return 'PLAN';
  if (flowOrganize) return 'ORGANIZE';
  return toFlowUiMode(flow?.mode);
};
